/* eslint-disable react/no-danger */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Carousel } from 'react-responsive-carousel';
import SlideWrapper from '../SlideWrapper';
import styles from './styles.module.scss';
import { LocaleContext } from '../../Banner';
import { SlidePropTypes } from '../Slide/Slide';

const customRenderItem = (item, props) => <item.type {...item.props} {...props} />;

const BannerSliderWrapper = ({
  sliderData,
  isMobile,
  sliderFooter,
  slideChange,
  showIndicators = false,
  interval = 6000,
}) => {
  const [activeBanner, changeActiveBanner] = useState(0);
  const { dataJurisdiction } = useContext(LocaleContext);

  const setControlDotsTop = () => {
    if (!isMobile) return;

    const sliderWrapper = document.getElementById('slider-wrapper');
    if (!sliderWrapper) return;

    const selectedSlide = sliderWrapper.querySelector('.slide.selected');
    if (!selectedSlide) return;

    const controlDots = document.querySelector('.control-dots');
    if (!controlDots) return;

    const headerHeight = Number(selectedSlide.querySelector('header')?.getAttribute('data-header-height'));
    // banner image height on mobile is always 180px plus 6px for spacing
    const headerAndImageHeight = ['en-uk', 'en-ir'].includes(dataJurisdiction)
      ? headerHeight + 196
      : headerHeight + 186;
    controlDots.style.top = `${headerAndImageHeight}px`;
  };

  const changeSlide = num => {
    changeActiveBanner(num);
    slideChange(num);
    setControlDotsTop();
  };

  useEffect(() => {
    if (sliderData.length > 0) {
      slideChange(0);
      setControlDotsTop();
    }
  }, []);

  if (!sliderData.length) {
    return null;
  }

  return (
    <div
      id="slider-wrapper"
      className={cn(styles.sliderWrapper)}
      data-jurisdiction={dataJurisdiction}
      data-testid="common-slider"
      style={{ background: ['en-uk', 'en-ir'].includes(dataJurisdiction) ? '#060A2A' : '' }}
    >
      {sliderData.length === 1 ? (
        <SlideWrapper slider={sliderData[0]} num={0} key={sliderData[0].img} isMobile={isMobile} />
      ) : (
        <Carousel
          data-testid="slider-carousel"
          autoPlay
          interval={interval}
          aria-label="Offers"
          renderItem={customRenderItem}
          selectedItem={activeBanner}
          showIndicators={showIndicators}
          showThumbs={false}
          showStatus={false}
          showArrows
          onChange={changeSlide}
          infiniteLoop
        >
          {sliderData.map((slider, key) => (
            <SlideWrapper slider={slider} num={key} key={slider.img} isMobile={isMobile} />
          ))}
        </Carousel>
      )}
      {sliderFooter}
    </div>
  );
};

BannerSliderWrapper.defaultProps = {
  sliderFooter: <></>,
  slideChange: () => {},
};

BannerSliderWrapper.propTypes = {
  sliderData: PropTypes.arrayOf(SlidePropTypes.slider).isRequired,
  isMobile: PropTypes.bool.isRequired,
  sliderFooter: PropTypes.node,
  slideChange: PropTypes.func,
  showIndicators: PropTypes.bool.isRequired,
  interval: PropTypes.number.isRequired,
};

export default BannerSliderWrapper;
